import type { AnyAction } from 'redux'

export const setResaleAuthorizationsPageNumber = (pageNumber: number) =>
  ({
    type: 'RESALE_SET_PAGE_NUMBER',
    payload: pageNumber,
  }) as unknown as AnyAction

export const clearResaleAuthorizations = () => ({
  type: 'RESALE_CLEAR_RESELLER_DATA',
})
